/**
 * Editor-only look of the ArticleIndex placeholder (C-24, design review 2026-10-07).
 *
 * The article rules (`articleRulesCss.ts`) ship only inside the published page's <style data-article-presentation>, under
 * `[data-content-kind="article"]`; the Studio editor preview has neither, so the placeholder rendered as a bulleted
 * list in the editor chrome's text colour (white on the light article canvas in dark mode). The editor renders this
 * sheet once next to ArticleIndexPreviewContext, and ArticleIndex marks its placeholder with
 * `data-article-index-preview` only under that context — published pages and funnels never get either.
 *
 * Values are the approved mock's (`.design/articles-path-mode/mockups/article-index-editor-placeholder.html`):
 * article tokens first, the default light article template's values as fallbacks.
 */
const S = '[data-article-index-preview]';

const INK = 'var(--ap-color-ink,#242424)';
const MUTED = 'var(--ap-color-muted,#5f5f5f)';
const RULE = 'var(--ap-color-rule,#e6e6e6)';
const PANEL = 'var(--ap-color-panel-2,#ecebf3)';

export const ARTICLE_INDEX_PREVIEW_ATTRIBUTE = 'data-article-index-preview';

export const ARTICLE_INDEX_PREVIEW_CSS = [
  `${S}{width:100%;box-sizing:border-box;text-align:left;color:${INK}}`,
  `${S} .ap-panel-title{margin:0 0 16px;font-size:24px;line-height:1.3;font-weight:800;letter-spacing:-0.025em;color:${INK}}`,
  `${S} .ap-index-list{list-style:none;margin:0;padding:0;border-top:1px solid ${RULE}}`,
  `${S} .ap-index-item{display:flex;align-items:flex-start;gap:24px;margin:0;padding:16px 0;border-bottom:1px solid ${RULE}}`,
  `${S} .ap-index-cover{display:block;flex:none;width:clamp(112px,30%,176px);aspect-ratio:16/9;box-sizing:border-box;border:1px solid ${RULE};border-radius:12px;background-color:${PANEL}}`,
  `${S} .ap-index-body{display:flex;min-width:0;flex:1;flex-direction:column;gap:8px}`,
  `${S} .ap-index-meta{margin:0;font-size:14px;line-height:1.4;font-weight:500;color:${MUTED}}`,
  `${S} .ap-index-title{margin:0;font-size:18px;line-height:1.3;font-weight:700;color:${MUTED}}`,
  `${S} .ap-index-ph-bar{display:block;height:10px;border-radius:5px;background-color:${PANEL}}`,
  `${S} .ap-index-ph-note{margin:16px 0 0;font-size:14px;line-height:1.4;font-weight:500;color:${MUTED}}`,
].join('');
